<div class="student-detail w-100">

    <p-tabView>

        <p-tabPanel header="Datos generales">

            <div class="container-fluid p-0">

                <div class="row w-100">

                    <div class="col-12 col-lg-6">
                        <app-student-detail-general
                            [student]="student">
                        </app-student-detail-general>
                    </div>

                    <div class="col-12 col-lg-6">
                        <app-student-detail-school
                            [student]="student">
                        </app-student-detail-school>
                    </div>

                </div>

            </div>

        </p-tabPanel>

        <p-tabPanel header="Información de interés">

            <div class="container-fluid p-0">

                <div class="row w-100">

                    <div class="col-12">
                        <app-student-detail-extra-info
                            [student]="student">
                        </app-student-detail-extra-info>
                    </div>

                </div>

            </div>

        </p-tabPanel>

    </p-tabView>

</div>
